import { useMemo } from 'react'
import { TFiltersConfiguration } from './TFiltersConfiguration'

export const useTranslationsFromFiltersConfiguration = (
  configuration: TFiltersConfiguration
) => {
  const getTranslation = useMemo(() => {
    const translations: Record<string, string> = {}

    for (const feature of configuration.features) {
      translations[feature.machineAttribute] = feature.label
    }

    for (const rangeFilter of configuration.rangeFilters) {
      translations[rangeFilter.machineAttribute] = rangeFilter.label
    }

    return function getTranslation(key: string) {
      return translations[key]
    }
  }, [configuration])

  return { getTranslation }
}
